import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

// Model
import {ResponseBase} from '../models/response-base';
import {EnderecoCep, EnderecoCidade, EnderecoUf} from '../models/endereco';

@Injectable({
    providedIn: 'root'
})
export class EnderecoService {
    API: string = environment.API + 'Portal/enderecos';

    constructor(private http: HttpClient) {
    }


    getCEP(cep: string): Observable<ResponseBase<EnderecoCep>> {
        return this.http.get<ResponseBase<EnderecoCep>>(`${this.API}/consultacep/${cep}`);
    }

    getUf(): Observable<ResponseBase<EnderecoUf[]>> {
        return this.http.get<ResponseBase<EnderecoUf[]>>(`${this.API}/uf`);
    }

    getCidade(uf: string): Observable<ResponseBase<EnderecoCidade[]>> {
        return this.http.get<ResponseBase<EnderecoCidade[]>>(`${this.API}/cidades/uf/${uf}`);
    }

}
